import React, { useCallback } from 'react';

import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { EToasterStatus, showToast } from 'utils/showToast';
import { z } from 'zod';

import Button from 'components/Button/Button';

import { IBlock } from '../constants';
import { pageFormSchema } from '../validation-schema';

const downloadJSON = (data: any, filename: string) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const BlocksExport: React.FC = () => {
  const { watch } = useFormContext<z.infer<typeof pageFormSchema>>();
  const currentBlocks = watch('blocksV2') as IBlock[] | undefined;
  const { portalId } = useParams();

  const handleExport = useCallback(() => {
    if (!currentBlocks || currentBlocks.length === 0) {
      showToast({
        message: 'No blocks to export',
        status: EToasterStatus.ERROR
      });
      return;
    }

    try {
      const blocksObjectToExport = {
        portalId,
        blocks: currentBlocks
      };
      downloadJSON(blocksObjectToExport, `blocks-${portalId}.json`);
      showToast({
        message: 'Blocks exported successfully',
        status: EToasterStatus.SUCCESS
      });
    } catch (error) {
      console.error('Export error:', error);
      showToast({
        message: 'Failed to export blocks',
        status: EToasterStatus.ERROR
      });
    }
  }, [currentBlocks]);

  return (
    <Button
      onClick={handleExport}
      variant="outline"
      type="button"
      className="text-sm w-[100px] text-base-secondaryForeground"
      leftIcon={<FontAwesomeIcon icon="fa-light fa-upload" />}
    >
      Export
    </Button>
  );
};
